import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { generateColors, withBarSelection } from '../../dashboard-helpers';

interface DataType {
  count: number[];
  name: LangType[];
}

export const useEmployeeTasksCount = (): ChartProps => {
  const { getLocale, t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.tasks_by_employee as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      const isDataExist = data.count.some((count) => count > 0);

      return {
        series: isDataExist ? [{ name: t('Кол-во задач'), data: data.count }] : [],
        options: {
          chart: {
            type: 'bar',
          },
          colors: generateColors(data.count.length),
          plotOptions: {
            bar: {
              horizontal: false,
              distributed: true,
              borderRadius: 6,
              borderRadiusApplication: 'around',
            },
          },
          yaxis: {
            axisTicks: { show: false },
            axisBorder: { show: false },
          },
          xaxis: {
            axisTicks: { show: false },
            categories: data.name.map((name) => getLocale(name)),
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          grid: {
            show: false,
          },
          tooltip: {
            enabled: true,
            hideEmptySeries: true,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [getLocale, t, data]);

  return {
    series: chartData.series,
    options: withBarSelection(chartData).options,
    label: 'Количество задач по сотрудникам',
    subLabel:
      'Диаграмма показывает, сколько задач выполняет каждый сотрудник, упрощая оценку загрузки и эффективность распределения обязанностей.',
    type: 'bar',
    wrapped: true,
  };
};
